// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../../../../../../node_modules/@glennsl/bs-json/src/Json.bs.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Fetch from "../../../../../../node_modules/bs-fetch/src/Fetch.bs.js";
import * as Config from "../../../../../Config.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as NetworkUtils from "../../../../../library/NetworkUtils.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as PromiseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/PromiseHandler.bs.js";
import * as PorterStoreOrderRepoConfig from "./PorterStoreOrderRepoConfig.bs.js";
import * as PorterStoreOrderUpdatePayloadMapper from "../entity-mapper/PorterStoreOrderUpdatePayloadMapper.bs.js";
import * as PorterStoreOrderUpdatePayloadApiModel from "../api-model/PorterStoreOrderUpdatePayloadApiModel.bs.js";

function fetchOrders(geoRegionId, status, offset, limit, mobile) {
  var mobileParam = mobile !== "" ? "&mobile=" + mobile : "";
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/merchandise" + "/orders?geo_region_id=" + String(geoRegionId) + "&status=" + status + "&offset=" + String(offset) + "&limit=" + String(limit) + mobileParam;
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    "Content-Type": "application/json"
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PorterStoreOrderRepoConfig.PorterStoreOrderListResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchOrderDetail(orderId) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/merchandise" + "/orders/" + orderId;
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    "Content-Type": "application/json"
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PorterStoreOrderRepoConfig.PorterStoreOrderDetailResponseConverter.execute, result);
                            });
                }), requestUrl);
}

var stripNulls = (function stripNulls(obj) {
      return JSON.parse(JSON.stringify(obj, (key, value) => value === null ? undefined : value))
    });

function updateOrder(orderId, payload) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/merchandise" + "/orders/" + orderId;
  var body = Json.stringify(stripNulls(PorterStoreOrderUpdatePayloadApiModel.t_encode(PorterStoreOrderUpdatePayloadMapper.execute(payload))));
  var headers = {
    "Content-Type": "application/json",
    Accept: "application/json"
  };
  var promise = fetch(requestUrl, Fetch.RequestInit.make(/* Patch */8, Caml_option.some(headers), Caml_option.some(body), undefined, undefined, /* CORS */3, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined));
  return NetworkUtils.catchPromiseError(PromiseHandler$Catalyst.PromiseHandler.resolvePromise(promise, 15000, requestUrl).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PorterStoreOrderRepoConfig.PorterStoreOrderDetailResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchOrderProducts(orderId) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/merchandise" + "/orders/" + orderId + "/products";
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    "Content-Type": "application/json"
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PorterStoreOrderRepoConfig.PorterStoreOrderProductsResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function createPaymentLink(orderUuid) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/merchandise" + "/payment-links";
  var payload = JSON.stringify(Js_dict.fromArray([[
              "order_uuid",
              orderUuid
            ]]));
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.post(requestUrl, {
                    "Content-Type": "application/json"
                  }, payload, undefined, /* Include */2, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PorterStoreOrderRepoConfig.PorterStorePaymentLinkResponseConverter.execute, result);
                            });
                }), requestUrl);
}

var PorterStoreOrderRepo = {
  fetchOrders: fetchOrders,
  fetchOrderDetail: fetchOrderDetail,
  updateOrder: updateOrder,
  createPaymentLink: createPaymentLink,
  fetchOrderProducts: fetchOrderProducts
};

export {
  PorterStoreOrderRepo ,
  
}
/* Config Not a pure module */
